'use strict';

const isNode = typeof document === 'undefined';

const _ = require('lodash');
const Classnames = require('classnames');
const React = require('react');
const ReactRouter = require('react-router');
const LinkedStateMixin = require('react-addons-linked-state-mixin');
const Reflux = require('reflux');

const History = ReactRouter.History;
const Link = ReactRouter.Link;

const Components = require('../../components');
const Constants = require('../../constants');
const Global = require('../../global');
const Store = require('../../store').Store;

const DeviceImage = Global.DeviceImage;
const Media = Components.Media;
const ResponsiveMixin = Global.ResponsiveMixin;

const ItemTabs = require('./item-tabs.jsx');

const PRODUCT_THUMB_W = 600;
const PRODUCT_THUMB_H = 400;
const PRODUCT_THUMB_PAD_DESKTOP = 40;
const PRODUCT_THUMB_PAD_MOBILE = 20;
const COMMON_ASPECT_RATIO = 0.6;  // Optimize for common 5:3 aspect ratio

import {Slider} from "../../components/slider"
import {Modal} from "../../components/modal"
import {EditCopy} from "../../components/edit-copy"
import {Lightbox,Lightboxes} from "../../components/lightbox"
import {thumb, scaled} from "../../thumbs"
import {hasAuth} from "../../auth"
import MobileDetect from "mobile-detect"
import {detect} from "detect-browser"
import * as nlp from "../../nlp"
// import zoom from "../../../../server/public/static/images/collection/zoom.png"

if (!isNode) {
    require('./experiment-product-page-with-form-item-detail.scss');
}

module.exports = React.createClass({
    mixins: [
        History,
        LinkedStateMixin,
        ResponsiveMixin,
        Reflux.connect(Store, 'store'),
    ],

    getInitialState() {
        return {
            lightbox: undefined,
            recent: [],
            sliders: {},
            readMore: false,
            sizesConfiguration: false,
            pricing: false,
        }
    },

    componentDidMount() {
        this.reset()
    },

    reset() {
        for (const s of Object.values(this.state.sliders))
            s && s.reset && s.reset()
        this.setState({
            lightbox: undefined,
            readMore: false,
            sizesConfiguration: false,
            pricing: false,
            recent: this.state.store.recentlyViewed.filter(i => i.url !== window.location.pathname),
        })
    },

    readMore(e) {
        this.setState({readMore: !this.state.readMore}) 
    },
    sizesConfiguration(e) {
        this.setState({sizesConfiguration: !this.state.sizesConfiguration}) 
    },
    pricing(e) {
        this.setState({pricing: !this.state.pricing}) 
    },

    arrows() {
        for (const s of Object.values(this.state.sliders))
            s && s.arrows && s.arrows()
    },

    render() {
        const item = this.props.item.item;
        const finishesIntro = item.descriptions.finish ||  this.props.item.text['collections.finishes' + (this.props.item.finishes.length ? '' : '-blank')]
        const copy = nlp.join([item.descriptions.splash, item.descriptions.story],'\n')
        const tabsWidth  = Constants.Breaks.DesktopWidth - PRODUCT_THUMB_W;
        const summaryWords = 100
        const auth = hasAuth(['admin', 'copy'])
        const details = this.props.item.details || []
        const finishes = this.props.item.finishes || []
        const scroll = { scroll: this.state.viewportLayout != 'desktop' }
        const modalColWidth = item.descriptions.size ? 510 : 1050

        let pad,
            container_w,
            container_h;

        if (this.state.viewportLayout == 'desktop') {
            pad         = PRODUCT_THUMB_PAD_DESKTOP;
            container_w = PRODUCT_THUMB_W;
            container_h = PRODUCT_THUMB_H - 40;
        } else {
            pad         = PRODUCT_THUMB_PAD_MOBILE;
            container_w = this.state.viewportWidth;
            container_h = COMMON_ASPECT_RATIO * container_w;
        }

        // limit height to PRODUCT_THUMB_W x PRODUCT_THUMB_H; size of co-item-thumb
        const aspect = item.width / item.height;
        let thumb_w = Math.min(item.width, container_w - pad);    
        const thumb_h = Math.min(container_h - pad, thumb_w * (1 / aspect));
        thumb_w = thumb_h * aspect;

        const mobile = window.innerWidth < 500
        const md = new MobileDetect(window.navigator.userAgent);
        const checkDevice = () => md.mobile() || md.tablet() 
        const checkBrowser = () => {
            const browser = detect()
            return !!browser && browser.name 
        }
        const RecentlyViewed =
            <div>
                <h3 className="recent-header">Recently Viewed</h3>
                <Slider attach={this.state.sliders} name='recent'
                        scroll={2/3}
                        height={150}
                        width={156*3}
                        >
                    {this.state.recent.map((a,i) => 
                        <p key={i}>
                            <Link to={a.url} state={scroll} onClick={this.reset}>
                                <img onLoad={()=>this.arrows()}
                                        src={thumb(a.filename, 148, 148)}
                                    />
                            </Link>
                        </p>
                    )}
                </Slider>
            </div>
        return (
            <div className='co-item-detail'>
                <div className='co-item-detail-column'>
                    {/* .co-item-thumb: */}
                    <ItemImage item              = {item}
                               width             = {thumb_w}
                               height            = {thumb_h}
                               location          = {this.props.location}
                               relatedItemsIndex = {this.props.relatedItemsIndex}
                               groupItemsIndex   = {this.props.groupItemsIndex}
                               pinterest         = {this.props.item.pinterest} />

                    <Slider attach={this.state.sliders} name='group'
                            scroll={2/3}
                            height={80}
                            width={86*6}
                            >
                        {this.props.groupItems.map((a,i) => 
                            <p key={i}>
                                <Link to={a.url} state={scroll}>
                                    <img onLoad={()=>this.arrows()}
                                         src={thumb(a.filename, 78, 78)}
                                         />
                                </Link>
                            </p>
                        )}
                    </Slider>
                    {!mobile && this.state.recent.length ? RecentlyViewed : null}   
                </div>
                <div className='co-item-detail-column' style={{position: 'relative'}}>
                    {auth
                        ? <a style={{
                            position: 'absolute',
                            right: '5px',
                            top: '5px',
                            color: 'black'
                            }}
                            href={'/cms/groups/'+item.groupID}
                            target="_blank"
                            >
                            Open in CMS
                        </a>
                        : undefined
                    }
                    <div className='product-detail-copy'>
                        {item.seriesDisplayname
                            ? <h1>{item.seriesDisplayname}</h1>
                            : <h1>Item #{item.id}</h1>
                        }
                        <div className="product-tags">
                            {item.tags.map((a,i) => <span key={i}>{a}</span>)}
                        </div>
                        <div className="product-details" dangerouslySetInnerHTML={{ __html: this.state.readMore ? copy : nlp.head(copy, summaryWords, '&hellip;')}} />


                        <div className="seo"
                             style={{position: 'absolute', opacity: '0', pointerEvents: 'none'}}
                             dangerouslySetInnerHTML={{__html: nlp.tail(copy, summaryWords)}}
                             />

                        <div className="buttons">
                            {nlp.wordcount(copy) <= summaryWords ? undefined :
                                <button className="read-more" onClick={this.readMore}>Read {this.state.readMore ? 'Less' : 'More'}</button>
                            }
                            <Modal button="Sizes &amp; Configurations" onopen={()=>this.arrows()}>
                                <h1>Sizes and Configurations</h1>
                                <div className="single-column-mobile" style={{
                                    display: 'grid',
                                    gridTemplateColumns: item.descriptions.size && !mobile ? '1fr 1fr' : '1fr',
                                    gridGap: '30px'
                                    }}>
                                    {item.descriptions.size ?
                                        <div>
                                            <h2>Dimensions</h2>
                                            <div dangerouslySetInnerHTML={{__html: item.descriptions.size}} />
                                        </div>
                                        : null
                                    }
                                    <div>
                                        {details.length ? <h2>Details</h2> : null}
                                        {details.length ?
                                            <Slider attach={this.state.sliders} name="details"
                                                    scroll={2/3}
                                                    width={modalColWidth}
                                                    height={80}
                                                    align="left"
                                                    >
                                                {details.map((a,i) =>
                                                    <p key={i}>
                                                        <Lightbox src={a}>
                                                            <img onLoad={()=>this.arrows()}
                                                                 src={scaled(a, {height: 78})}
                                                                 />
                                                        </Lightbox>
                                                    </p>
                                                )}
                                            </Slider>
                                            : null
                                        }
                                        <h2>Finishes</h2>
                                        {finishes.length ?
                                            <Slider attach={this.state.sliders} name="finishes"
                                                    scroll={2/3}
                                                    width={modalColWidth}
                                                    height={80}
                                                    align="left"
                                                    >
                                                {finishes.map((a,i) =>
                                                    <p key={i} style={{background: 'black'}}>
                                                        <Lightbox src={a}>
                                                            <img onLoad={()=>this.arrows()}
                                                                src={scaled(a, {height: 78})}
                                                                title={a.name}
                                                                />
                                                        </Lightbox>
                                                     </p>
                                                )}
                                            </Slider>
                                            : null
                                        }
                                        <div dangerouslySetInnerHTML={{__html: finishesIntro}} />
                                    </div>
                                </div>
                            </Modal>

                            <Modal button="Pricing">
                                <h1>Pricing</h1>
                                <div className="single-column-mobile" style={{display: 'grid', gridTemplateColumns: '1fr 1fr', gridGap: '30px'}}>
                                    <div style={{position: 'relative'}}>
                                        <EditCopy name="collections.pricing.left-column" />
                                        <div dangerouslySetInnerHTML={{__html: Payload.text['collections.pricing.left-column']}} />
                                    </div>
                                    <div style={{position: 'relative'}}>
                                        <EditCopy name="collections.pricing.right-column" />
                                        <div dangerouslySetInnerHTML={{__html: Payload.text['collections.pricing.right-column']}} />
                                        <a href="/budget-your-office">
                                            <button style={{textTransform:'uppercase'}}>
                                                Launch Budget Your Office Tool
                                            </button>
                                        </a>
                                    </div>
                                </div>
                            </Modal>
                        </div>
                    </div>

                    <Lightboxes />

                    <form id="lead-form" action="/api/lead" method="POST">
                        <h4>Get a quote for this item and your entire workspace furniture project</h4>
                        <div style={{display:'grid',gridTemplateColumns:'1fr 1fr',gridGap:'5px'}}>
                            <label>First Name</label>
                            <label>Last Name</label>
                            <input name="firstname" placeholder="First Name" required />
                            <input name="lastname" placeholder="Last Name" required />
                        </div>
                        <div style={{display:'grid',gridTemplateColumns:'1fr'}}>
                            <label>Email</label>
                            <input name="email" type="email" placeholder="Your Email" required />
                            <label>Phone Number</label>
                            <input name="phone" type="tel" placeholder="Your company phone number" required />
                            <label>Your Project</label>
                            <textarea name="description" placeholder="Tell us about your project..." />
                            <label>Position</label>
                            <input name="job" type="text" placeholder="Your position" />
                            <label>Company</label>
                            <input name="company" type="text" placeholder="Your company" />
                            <label>City</label>
                            <input name="city" type="text" placeholder="Your city" />
                            <label>Region</label>
                            <input name="region" type="text" placeholder="Your region" />
                            <input type="submit" value="Request a Quote" />
                        </div>
                        <input type="hidden" name="device" value={checkDevice() || 'desktop'} readOnly />
                        <input type="hidden" name="browser" value={checkBrowser()} readOnly />
                        <input type="hidden" name="source" value="product" readOnly />
                        <input type="hidden" name="ga" value={!!window[window['GoogleAnalyticsObject'] || 'ga']} readOnly />
                        <input type="hidden" name="path" value={isNode ? "" : window.location.pathname} readOnly />
                        <input type="hidden" name="items" value={JSON.stringify([{id:item.id,quantity:1, note:''}])} readOnly />
                    </form>
               </div>
               {mobile && this.state.recent.length ? RecentlyViewed : null}   
            </div>
        );
    }
});

var ItemImage = React.createClass({
    mixins: [ History, LinkedStateMixin, ResponsiveMixin ],

    _onClick: function() {
        // When showing zoomed image, record in history.state the position of the galleries
        // so when the user clicks Back, the gallery page offset is preserved
        history.replaceState({
            'relatedItemsIndex': this.props.relatedItemsIndex.value,
            'groupItemsIndex': this.props.groupItemsIndex.value,
        }, window.location.pathname);
    },
    render: function() {
        var item = this.props.item;
        var thumbStyle = {
            width: Math.round(this.props.width),
            height: Math.round(this.props.height),
        };

        var basepath = this.props.location.pathname.replace(/\/tab\/?(story|finishes|details)$/, '');

        // Move Pinterest badge to top-left of photo
        const PinterestStyle = {
            top:  `calc(${(PRODUCT_THUMB_H - this.props.height) / 2}px + 1em`,
            left: `calc(${(PRODUCT_THUMB_W  - this.props.width) / 2}px + 1em`,
        };

        return (
            <div className='co-item-thumb'>
                <Link to={`/image/${item.imageID}`} state={{ fromProduct: item.id }} onClick={this._onClick}>
                    <div className='co-item-thumb-container' style={thumbStyle}>

                        <Media className = 'co-item-thumb-img'
                               media     = {item}
                               width     = {thumbStyle.width}
                               crossfade />

                        {this.state.viewportLayout == 'desktop' ?
                            <div className='co-item-thumb-zoom'>
                                <DeviceImage src={'collection/zoom.png'} width="25" height="25" base64={true} />
                            </div>
                        : null}
                    </div>
                </Link>
                {this.state.viewportLayout == 'desktop' ?
                    <Components.Pinterest pinterest={this.props.pinterest} style={PinterestStyle} />
                : null}
            </div>
        );
    }
});



// WEBPACK FOOTER //
// ./src/collections/product/experiment-product-page-with-form-item-detail.jsx